<app-summary-field [value]="item.common.label" [class]="selectable ? 'cursor-pointer' : ''" (click)="selected()">
    <i-tabler icon style="margin: auto;" *ngIf="iconName"
              [name]="iconName"
              [style.color]="item.common.color"
              class="icon-18 d-flex m-r-4"></i-tabler>
    <app-button buttons iconName="x" (clickEvent)="delete()" *ngIf="deletable"></app-button>
</app-summary-field>
